import { CareEnvironment, isNullOrUndefined } from '.';

type ClientCareEnvironmentCost = {
  rateAmount: number;
  ratePeriod: string;
  hasCustomRate: boolean;
  rateLocaleDescription: string;
  originalRateAmount?: number;
  discount?: {
    percent: number;
    amount: number;
    label: string;
    description: string;
    reason: 'policyType';
    policyType: FundingPolicyType;
  };
};

export function pickClientCareEnvironmentCosts(
  client: Client,
  careEnvironment: CareEnvironment,
): ClientCareEnvironmentCost {
  const { careEnvironmentCosts, clientLocalCareEnvironmentCosts } = client;

  const localRateData = clientLocalCareEnvironmentCosts[careEnvironment];
  const selectedCareSettingCost = careEnvironmentCosts
    ? careEnvironmentCosts[careEnvironment]
    : undefined;

  const hasCustomRate =
    !isNullOrUndefined(careEnvironmentCosts) && !isNullOrUndefined(selectedCareSettingCost);

  if (hasCustomRate) {
    // Use custom rate - no discount applied to custom rates
    return {
      rateAmount: selectedCareSettingCost,
      ratePeriod: localRateData.ratePeriod,
      hasCustomRate: true,
      rateLocaleDescription: 'Edited rate',
    };
  } else {
    // Use local rate data which already includes discounts applied on the backend
    return {
      rateAmount: localRateData.rateAmount,
      ratePeriod: localRateData.ratePeriod,
      hasCustomRate: false,
      rateLocaleDescription: localRateData.rateLocaleDescription,
      originalRateAmount: localRateData.originalRateAmount,
      discount: localRateData.discount,
    };
  }
}
